/* eslint-disable react/no-array-index-key */
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';

import { useSelect } from 'downshift';
import Label from '@components/Form/Label';
import { ChevronDownIcon } from '@radix-ui/react-icons';

interface Props {
  choices: string;
  clean_name: string;
  label: string;
  default_value: string;
}

function SelectFieldComponent(props: Props) {
  const { choices, clean_name: cleanName, label, default_value: defaultValue } = props;
  const items = choices.split(',');
  const {
    isOpen,
    selectedItem,
    getToggleButtonProps,
    getLabelProps,
    getMenuProps,
    highlightedIndex,
    getItemProps,
  } = useSelect({
    items,
    defaultSelectedItem: defaultValue || items[0],
  });

  return (
    <div className='downshift-select'>
      <Label {...getLabelProps()} text={label} />
      <button className='downshift-select__button' type='button' {...getToggleButtonProps()}>
        <span>{selectedItem ?? 'keine Auswahl'}</span>{' '}
        <div className='downshift-select__chevron'>
          <ChevronDownIcon width={48} height={48} />
        </div>
      </button>
      <ul {...getMenuProps()} className='downshift-select__list'>
        {isOpen &&
          items.map((item, index) => (
            <li
              className='downshift-select__list-item'
              style={highlightedIndex === index ? { backgroundColor: '#bde4ff' } : {}}
              key={`${item}${index}`}
              {...getItemProps({ item, index })}
            >
              {item}
            </li>
          ))}
      </ul>
      <VisuallyHidden.Root>
        <input name={cleanName} defaultValue={selectedItem ?? ''} type='hidden' />
      </VisuallyHidden.Root>
    </div>
  );
}

export default SelectFieldComponent;
